/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsid } from './FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsid';
import {
    FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsidFromJSON,
    FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsidFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsidToJSON,
    FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsidToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsid';

/**
 * Параметры аутентификации FB Instant Games.
 * Для обычного режима заполняется ApplicationScopedId (ASID).
 * Для Zero Permissions (NEZP) режима заполняется PlayerId.
 * Ровно одно из двух полей должно быть заполнено.
 * @export
 * @interface FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions
 */
export interface FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions {
    /**
     * ASID — для существующих юзеров, принявших TOS.
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions
     */
    ApplicationScopedId?: string | null;
    /**
     * Player ID — для NEZP-юзеров без TOS.
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions
     */
    PlayerId?: string | null;
    /**
     * Подпись ASID для парного запроса. Основная Signature в этом случае подписывает Player ID.
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions
     */
    ApplicationScopedIdSignature?: string | null;
    /**
     * Запрещает создание нового аккаунта, но разрешает найти существующий и добавить недостающий идентификатор.
     * null сохраняет поведение старых клиентов.
     * @type {boolean}
     * @memberof FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions
     */
    ExistingAccountOnly?: boolean | null;
    /**
     * ASID игрока в связанных приложениях из getSignedAssociatedAppsASIDAsync. null — старые клиенты или галка выключена.
     * @type {Array<FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsid>}
     * @memberof FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions
     */
    AssociatedApps?: Array<FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsid> | null;
    /**
     *
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions
     */
    Signature: string;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions(value: object): value is FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions {
    if (!('Signature' in value) || value['Signature'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsFromJSON(json: any): FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions {
    return FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions {
    if (json == null) {
        return json;
    }
    return {

        'ApplicationScopedId': json['ApplicationScopedId'] == null ? undefined : json['ApplicationScopedId'],
        'PlayerId': json['PlayerId'] == null ? undefined : json['PlayerId'],
        'ApplicationScopedIdSignature': json['ApplicationScopedIdSignature'] == null ? undefined : json['ApplicationScopedIdSignature'],
        'ExistingAccountOnly': json['ExistingAccountOnly'] == null ? undefined : json['ExistingAccountOnly'],
        'AssociatedApps': json['AssociatedApps'] == null ? undefined : ((json['AssociatedApps'] as Array<any>).map(FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsidFromJSON)),
        'Signature': json['Signature'],
    };
}

export function FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsToJSON(json: any): FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions {
    return FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsToJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsToJSONTyped(value?: FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'ApplicationScopedId': value['ApplicationScopedId'],
        'PlayerId': value['PlayerId'],
        'ApplicationScopedIdSignature': value['ApplicationScopedIdSignature'],
        'ExistingAccountOnly': value['ExistingAccountOnly'],
        'AssociatedApps': value['AssociatedApps'] == null ? undefined : ((value['AssociatedApps'] as Array<any>).map(FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesAssociatedAppAsidToJSON)),
        'Signature': value['Signature'],
    };
}
